export const isUserVip = (userData) =>
  userData?.isVip === true || userData?.isVip === "true";

const getMessageSenderId = (msg) => {
  if (msg?.msgByUserId && typeof msg.msgByUserId === "object") {
    return msg.msgByUserId._id || msg.msgByUserId.id || null;
  }
  return msg?.msgByUserId || msg?.sender?._id || msg?.senderId || null;
};

export const isMessageVip = (msg, ...knownUsers) => {
  if (msg?.msgByUserId && typeof msg.msgByUserId === "object" && isUserVip(msg.msgByUserId)) {
    return true;
  }
  if (isUserVip(msg?.sender)) {
    return true;
  }

  const senderId = getMessageSenderId(msg);
  if (!senderId) return false;

  return knownUsers.flat().some((user) => {
    if (!isUserVip(user)) return false;
    const userId = user?._id || user?.id;
    return userId && String(senderId) === String(userId);
  });
};

export const vipMessageClass = (msg, ...knownUsers) =>
  isMessageVip(msg, ...knownUsers) ? " is-vip-bubble" : "";
